/* eslint-disable react/prop-types */
/**
=========================================================
* Soft UI Dashboard React - v4.0.1
=========================================================

* Product Page: https://www.creative-tim.com/product/soft-ui-dashboard-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// @mui material components
import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";

// Soft UI Dashboard React components

import MDBox from "~/components/MDBox";
import MDTypography from "~/components/MDTypography";

// Images

import { CardMedia, Divider } from "@mui/material";
import { Statistic } from "antd";
import noPreview from "~/assets/images/no-picture.png";
import MiniStatisticsCard from "../MiniStatisticsCard";
import { Carousel } from 'react-responsive-carousel';
import "react-responsive-carousel/lib/styles/carousel.min.css";

function DetailsCard({
  plantScientificName,
  plantEnglishName,
  locationName,
  plotName,
  plantName,
  plantCode,
  monitoringType,
  monitoringRemark,
  monitoringData,
  imgSrc,
  ...props
}) {
  const imageUrls = imgSrc ? imgSrc.split(',') : [noPreview];

  return (
    <Card>
      <MDBox variant="gradient" shadow="large" color="success" p={2}>
        <Grid container spacing={2}>
          <Grid item xs={12} lg={12}>
            <MDBox display="flex" flexDirection="column" height="100%">
              <MDBox pt={1} mb={0.5}>
                <MDTypography fontWeight="bold" color="success">
                  {plantName}{" "}
                  {
                    <MDTypography variant="span" color="text" gutterBottom>
                      {`(${plantEnglishName})`}
                    </MDTypography>
                  }
                </MDTypography>
              </MDBox>
              {/* <MDTypography variant="h5" fontWeight="bold" gutterBottom>
                {plantEnglishName}
              </MDTypography> */}

              <MDBox mb={1}>
                <Grid container spacing={3}>
                  <Grid item lg={6} md={6}>
                    <Statistic
                      title="Plant Scientific Name"
                      value={plantScientificName}
                    />
                  </Grid>
                  <Grid item lg={6} md={6}>
                    <Statistic title="Plant Code" value={plantCode} />
                  </Grid>
                  <Grid item lg={6} md={6}>
                    <Statistic title="Location Name" value={locationName} />
                  </Grid>
                  <Grid item lg={6} md={6}>
                    <Statistic title="Plot Name" value={plotName} />
                  </Grid>
                </Grid>
                <Divider />
                {monitoringRemark && (
                  <MDBox my={1}>
                    <MDTypography variant="buttonText" fontWeight="bold">
                      Monitoring Remark
                    </MDTypography>
                    <MDTypography variant="body2" color="text">
                      {monitoringRemark}
                    </MDTypography>
                  </MDBox>
                )}
              </MDBox>
              {/* <MDTypography
                component="a"
                href="#"
                variant="button"
                color="text"
                fontWeight="bold"
                sx={{
                  mt: 'auto',
                  mr: 'auto',
                  display: 'inline-flex',
                  alignItems: 'center',
                  cursor: 'pointer',

                  '& .material-icons-round': {
                    fontSize: '1.125rem',
                    transform: `translate(2px, -0.5px)`,
                    transition: 'transform 0.2s cubic-bezier(0.34,1.61,0.7,1.3)',
                  },

                  '&:hover .material-icons-round, &:focus  .material-icons-round': {
                    transform: `translate(6px, -0.5px)`,
                  },
                }}
              >
                Read More
                <Icon sx={{ fontWeight: 'bold' }}>arrow_backward</Icon>
              </MDTypography> */}
            </MDBox>
          </Grid>
          {/* TODO: Will use this heading if required and if suggested */}
          {/* <Grid item xs={12} lg={12}>
            <MDBox my={1}>
              <MDTypography variant="buttonText" fontWeight="bold" gutterBottom>
                {monitoringType} Data
              </MDTypography>
            </MDBox>
          </Grid> */}

          <Grid item lg={12}>
            <Grid container spacing={3}>
              <Grid item lg={12} md={12}>
                <Card
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    backgroundColor: "transparent",
                    boxShadow: "none",
                    overflow: "visible",
                  }}
                >
                  <MDBox
                    position="relative"
                    width="100.25%"
                    shadow="xl"
                    borderRadius="xl"
                  >
                    <Carousel showThumbs={false} infiniteLoop>
                      {imageUrls.map((url, index) => (
                        <CardMedia
                          key={index}
                          src={url}
                          component="img"
                          title={plantName}
                          sx={{
                            width: "100%",
                            height: "220px",
                            margin: 0,
                            boxShadow: ({ boxShadows: { md } }) => md,
                            objectFit: "cover",
                            objectPosition: "center",
                          }}
                        />
                      ))}
                    </Carousel>
                  </MDBox>
                </Card>
              </Grid>
              {/* {imgSrc && (
                <Grid
                  item
                  xs={12}
                  lg={6}
                  sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}
                >
                  <MDBox
                    bgColor="info"
                    borderRadius="lg"
                    variant="gradient"
                    width={'15rem'}
                    height={'4.5rem'}
                  >
                    <Image
                      src={imgSrc ?? plant}
                      width={'15rem'}
                      height={'4.5rem'}
                      preview={imgSrc === null ? false : true}
                    />
                  </MDBox>
                </Grid>
              )} */}
              {monitoringData?.map((item) => (
                <>
                  <Grid item xs={12} sm={12} lg={6} key={item.title}>
                    <MiniStatisticsCard
                      title={{ text: item.title }}
                      count={item.value ?? "Not Updated"}
                      //   percentage={{ color: 'success', text: '+55%' }}
                      icon={{ color: "info", component: "emoji_nature" }}
                    />
                  </Grid>
                </>
              ))}
            </Grid>
          </Grid>
        </Grid>
      </MDBox>
    </Card>
  );
}

export default DetailsCard;
